// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__3Sac4","appLoader":"App_appLoader__2O8eA"};